import * as React from "react";
import Image from 'next/image';
import Grid from '@mui/material/Unstable_Grid2';

const Why = () =>
{
    return <Grid container xs={12} className="why-sons margin-top-2">
        <Grid xs={2} className="margin-small-top-3">
            <Image src="/assets/images/campaign-against-living-miserably.svg"
                   width={48}
                   height={75}
                   alt="Campaign against living miserably"
            />
        </Grid>
        <Grid xs={8} className="padding-left-1">
            <span>A portion of this sale will be donated to Campaign against living miserably</span>
        </Grid>
    </Grid>
}

export default Why;